import { ActionHistoryReduxMiddleware, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { VwgActions } from './vwgActions';

export const risikoortActionHistory = new ActionHistoryReduxMiddleware(action => {
  return [
    GlobalActions.IMMOBILIE_UEBERNEHMEN,
    VwgActions.PLZ_CHANGED,
    GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL,
    VwgActions.ORT_CHANGED,
    VwgActions.STRASSE_CHANGED,
    VwgActions.HAUSNUMMER_CHANGED,
    VwgActions.LAND_CHANGED,
    VwgActions.ORTSTEIL_CHANGED,
    VwgActions.HAUSNRZUS_CHANGED,
    GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL,
    GlobalActions.AMIS_IMMOBILIEN_TRANSFORMED,
    GlobalActions.AMIS_CRM_IMMOBILIE_REQUEST_SUCCESSFUL,
    GlobalActions.ADRESSDATEN_REQUEST_SUCCESSFUL,
    GlobalActions.ADRESSDATEN_REQUEST_FAILED,
  ].includes(action.type);
});
